import React, { useContext, useEffect, useState } from "react";
import UserContext from "../../UserContext";
import { useNavigate } from "react-router-dom";
import './Dashboard.css';
import logo from '../../assets/logo.png'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown,faChevronUp, faGear, faHouse, faTicket } from "@fortawesome/free-solid-svg-icons";
import user from '../../assets/user.png'
import AccountSettings from "./Customer/AccountSettings/AccountSettings";
import MyTickets from "./Customer/MyTickets/MyTickets";

const Dashboard = () => {
  const navigate = useNavigate();

  const { userInfo, changes,setChanges, authenticated, logout,getUserDetails,userDetails,setUserDetails } = useContext(UserContext);
  const [activeOption,setActiveOption] = useState('tickets');
  const [triggetArrowDown,setTriggerArrowDown] = useState(false);
  const [loading, setLoading] = useState(true);
  const isMobile = window.innerWidth <= 768;

  useEffect(() => {
    if (!authenticated || userInfo === null) {
      navigate("/login");
    }
  }, [authenticated, userInfo, navigate]);

  const handleLogout = async () => {
    await logout();
  };

  const handleOptionChange = (e) => {
    setActiveOption(()=> e.target.id);
  }

  const handleArrowButton = () => {
    if(triggetArrowDown)
    setTriggerArrowDown(false)
    else 
      setTriggerArrowDown(true)
  }


  useEffect(()=> {
    getUserDetails(userInfo.email)
      .then((res) => {
        setUserDetails(res)
        setLoading(false)
        setChanges(false);
      })
      .catch((error) => console.error(error));
  },[changes])


  const navigateToHome = () => {
    navigate('/');
  }

  return (
    <div className="dashboard-outer-container">
      <div className="dashboard-container">
        <div className="dashboard-aside-container">
          <div className="dashboard-logo">
          <img className="logo-hover" onClick={navigateToHome} src={logo} alt="Logo" />
          </div>
          {/* <div onClick={(e)=>handleOptionChange(e)} id="discovery" className={activeOption==='discovery'?'dashboard-menu-item menu-active': 'dashboard-menu-item'}>
            Event Discovery
          </div> */}
          <div onClick={(e)=>handleOptionChange(e)} id="tickets" className={activeOption==='tickets'?'dashboard-menu-item menu-active': 'dashboard-menu-item'}>
          <FontAwesomeIcon icon={faTicket} style={{marginRight:"0.4em"}} />  Tickets
          </div>
          <div onClick={(e)=>handleOptionChange(e)} id="settings" className={activeOption==='settings'?'dashboard-menu-item menu-active': 'dashboard-menu-item'}>
          <FontAwesomeIcon  icon={faGear} style={{marginRight:"0.4em"}}/>  Account Settings
          </div>
        </div>
        <div className="dashboard-main-container">
          <div className="dashboard-header">
          <div></div>
          {isMobile ? <div onClick={navigateToHome} className="home-div-mobile"> <FontAwesomeIcon icon={faHouse} style={{color:"#61cdbb"}}/> <h3 className="mobile-home">Home</h3> </div> : <></>}
            <div className="header-icon">
            {loading ? <></>: <img className="user-icon" src={userDetails.picture || user} />}
              {loading ? (
                <></>
              ) : (
                <h4
                  style={
                    !triggetArrowDown
                      ? { margin: "0.5em" }
                      : { display: "none" }
                  }
                >
                  {userDetails.displayName}
                </h4>
              )}
                <h4 onClick={handleLogout} className="logout-menu" style={!triggetArrowDown ?{display:"none"} : {margin:"0.5em"}}>Logout</h4>
                <FontAwesomeIcon onClick={handleArrowButton} style={triggetArrowDown ?{display:"none"} : {}} className="arrow-icon" icon={faChevronDown} />
                <FontAwesomeIcon style={!triggetArrowDown ?{display:"none"} : {}} onClick={handleArrowButton} className="arrow-icon" icon={faChevronUp} />
                
                
            </div>
          </div>
          {activeOption==='discovery'? <></> : activeOption==='tickets' ? <MyTickets/>: activeOption==='settings'? <AccountSettings/>: <></>}
        
          <div className="dashboard-mobile-footer">
          <div onClick={(e)=>handleOptionChange(e)} id="tickets" className={activeOption==='tickets'?'dashboard-menu-item menu-active': 'dashboard-menu-item'}>
          <FontAwesomeIcon icon={faTicket} style={{marginRight:"0.4em"}} />  Tickets
          </div>
          <div onClick={(e)=>handleOptionChange(e)} id="settings" className={activeOption==='settings'?'dashboard-menu-item menu-active': 'dashboard-menu-item'}>
          <FontAwesomeIcon  icon={faGear} style={{marginRight:"0.4em"}}/>  Account Settings
          </div>
        </div>
        
        </div>

   
      </div>
    </div>
  );
};

export default Dashboard;
